import { gtcModal } from "gtcModal";
import { gtcOpenModalInDesignMode, gtcSetCookie, gtcGetCookie, gtcVideoAutoplay } from "gtcUtils";
class GtcPopup extends gtcModal {
    constructor() {
        super();
        this.openOnScroll = this.openOnScroll.bind(this);
        this.openOnTimout = this.openOnTimout.bind(this);
        this.openOnLeave = this.openOnLeave.bind(this);
    }

    async connectedCallback() {
        super.connectedCallback();


        window.addEventListener('pageshow', function(event) {
            // 'persisted' er sand, hvis siden hentes fra browserens hukommelse (bfcache)
            if (event.persisted || (window.performance && window.performance.navigation.type === 2)) {
              // Tving siden til at genindlæse fra serveren
              window.location.reload();
            }
          });

        this.settings = {
            ...this.settings,
            openOnScroll: this.hasAttribute('data-scroll-open'),
            openOnTimeout: this.hasAttribute('data-time-open'),
            openOnTimeoutDelay: this.hasAttribute('data-time-open') ? Number(this.getAttribute('data-time-open')) : 0,
            openOnLeave: this.hasAttribute('data-leave-open'),
            openCount: this.getCookie(),
            openMax: this.hasAttribute('data-open-max') ? Number(this.getAttribute('data-open-max')) : 0,
            cookieExpirationDays: this.hasAttribute('data-cookie-expiration-days') ? Number(this.getAttribute('data-cookie-expiration-days')) : 30
        }


        if (!(this.settings.openMax && this.settings.openCount >= this.settings.openMax)) {
            this.dom = {
                ...this.dom,
                parent: this.parentElement
            }

            
            if (!Shopify?.designMode) {
                const functionsArray = [this.settings.openOnScroll, this.settings.openOnTimeout, this.settings.openOnLeave].filter(Boolean);
                
                if (functionsArray.length > 0) {
                    if (this.settings.openOnScroll) {
                        await this.openOnScroll();
                    }
                    if (this.settings.openOnTimeout) {
                        await this.openOnTimout();
                    }
                    if (this.settings.openOnLeave) {
                        await this.openOnLeave();
                    }

                    this.setCookie();
                    this.open();
                }
            }
        }

        gtcOpenModalInDesignMode(this);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }

    async openOnLeave() {
        return new Promise((resolve) => {
            let openOnLeaveActivated = false;
            document.addEventListener('mouseleave', (event) => {
                if (event.clientY < 0 && !openOnLeaveActivated) {
                    openOnLeaveActivated = true;
                    resolve();
                }
            });
        });
    }

    async openOnScroll() {
        return new Promise((resolve) => {
            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 0.1
            }

            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        observer.unobserve(this.dom.parent);
                        resolve();
                    }
                });
            }, options);

            observer.observe(this.dom.parent);
        });
    }

    async openOnTimout() {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, this.settings.openOnTimeoutDelay);
        });
    }

    setCookie() {
        this.settings.openCount = this.settings.openCount + 1;
        gtcSetCookie(`gtc-popup-${ this.id }`, this.settings.openCount, this.settings.cookieExpirationDays);
    }

    getCookie() {
        return Number(gtcGetCookie(`gtc-popup-${ this.id }`)) || 0;
    }
}

if (!customElements.get('gtc-popup')) {
    customElements.define('gtc-popup', GtcPopup);
}

class VideoAutoplay extends gtcVideoAutoplay {
    // Add any initialization code here
    constructor() {
        super();
    }
}

if (!window.customElements.get('video-autoplay')) {
    customElements.define('video-autoplay', VideoAutoplay);
}
